export class ActivateAtlasOrganizationResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "atlasOrganization",
            "baseName": "atlasOrganization",
            "type": "AtlasOrganization",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ActivateAtlasOrganizationResponse.attributeTypeMap;
    }
    constructor() {
    }
}
